import { render, staticRenderFns } from "./DproductCreate.vue?vue&type=template&id=3db3414a&scoped=true"
import script from "./DproductCreate.vue?vue&type=script&lang=js"
export * from "./DproductCreate.vue?vue&type=script&lang=js"
import style0 from "./DproductCreate.vue?vue&type=style&index=0&id=3db3414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db3414a",
  null
  
)

export default component.exports